// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sub-admin › Projects list. */

.subadmin-projects__person {
  display: inline-flex;
  align-items: center;
  gap: var(--ds-space-2);
}

.subadmin-projects__person .ant-avatar {
  flex-shrink: 0;
}

.subadmin-projects__status {
  min-width: 140px;
}

/* The filter grid spans the whole toolbar instead of the default 260px filter slot. */
.subadmin-projects .page-toolbar__filters > .subadmin-projects__filters {
  flex: 1 1 100%;
}
`, "",{"version":3,"sources":["webpack://./src/subadmins/components/projects/SubadminProjects.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sFAAsF;AACtF;EACE,cAAc;AAChB","sourcesContent":["/* Sub-admin › Projects list. */\n\n.subadmin-projects__person {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n}\n\n.subadmin-projects__person .ant-avatar {\n  flex-shrink: 0;\n}\n\n.subadmin-projects__status {\n  min-width: 140px;\n}\n\n/* The filter grid spans the whole toolbar instead of the default 260px filter slot. */\n.subadmin-projects .page-toolbar__filters > .subadmin-projects__filters {\n  flex: 1 1 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
